<template>
  <div class="step-info">
    <div class="step-info__row">
      <div class="step-info__field step-info__field--full">
        <label>Título <span class="required">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="form.titulo"
          placeholder="Nome da sinaleira..."
          maxlength="255"
        />
      </div>
    </div>

    <div class="step-info__row">
      <div class="step-info__field step-info__field--full">
        <label>Descrição</label>
        <textarea
          class="form-control"
          v-model="form.descricao"
          placeholder="Descrição opcional..."
          rows="3"
          maxlength="500"
        ></textarea>
      </div>
    </div>

    <div class="step-info__row step-info__row--cols">
      <div class="step-info__field">
        <label>Ativo <span class="required">*</span></label>
        <select class="form-control" v-model="form.ativo">
          <option :value="1">Sim</option>
          <option :value="0">Não</option>
        </select>
      </div>

      <div class="step-info__field">
        <label>Exibe percentual de margem <span class="required">*</span></label>
        <select class="form-control" v-model="form.exibirPercentual">
          <option :value="1">Sim</option>
          <option :value="0">Não</option>
        </select>
      </div>
    </div>

    <div class="step-info__row step-info__row--cols">
      <div class="step-info__field">
        <label>Sistemas <span class="required">*</span></label>
        <div class="step-info__checkboxes">
          <label
            v-for="sistema in sistemasDisponiveis"
            :key="sistema.chave"
            class="step-info__checkbox"
          >
            <input
              type="checkbox"
              :checked="!!form[sistema.chave]"
              @change="toggleSistema(sistema.chave)"
            />
            {{ sistema.descricao }}
          </label>
        </div>
      </div>

      <div class="step-info__field">
        <label>Prioridade</label>
        <select class="form-control" v-model.number="form.prioridade">
          <option :value="0">Normal</option>
          <option :value="1">Prioritário</option>
        </select>
      </div>
    </div>

    <div class="step-info__row step-info__row--cols">
      <div class="step-info__field">
        <label>Modo de análise</label>
        <select class="form-control" v-model="form.modoAnalise">
          <option value="PADRAO">Padrão</option>
          <option value="RESTRITO">Restrito</option>
        </select>
        <small class="step-info__hint">
          <template v-if="form.modoAnalise === 'RESTRITO'">
            O orçamento fica <strong>bloqueado para edição</strong> enquanto a
            negociação estiver pendente ou aceita. Se os preços mudarem, a
            negociação é cancelada automaticamente e o vendedor precisa solicitar
            de novo.
          </template>
          <template v-else>
            O vendedor continua editando o orçamento durante a análise. A
            validação do envio confere apenas a margem contra a faixa liberada.
          </template>
        </small>
      </div>

      <div class="step-info__field"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepInformacoesGerais",
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return {
      sistemasDisponiveis: [
        { chave: "aplicacallcenter", descricao: "Callcenter" },
        { chave: "aplicafv", descricao: "Força de Vendas" },
      ],
    };
  },
  methods: {
    toggleSistema(chave) {
      this.form[chave] = this.form[chave] ? 0 : 1;
    },
  },
};
</script>

<style scoped>
.step-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-info__row {
  display: flex;
  gap: 16px;
}

.step-info__row--cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.step-info__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.step-info__field--full {
  flex: 1;
}

.step-info__hint {
  font-size: 11px;
  line-height: 1.45;
  color: #667085;
}

.step-info__hint strong {
  color: #3a3e81;
}

.step-info__field label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.step-info__field .form-control {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
  padding: 8px 10px;
}

.step-info__field .form-control:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.required {
  color: #e74c3c;
}

.step-info__checkboxes {
  display: flex;
  gap: 16px;
  padding-top: 4px;
}

.step-info__checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #344054;
  cursor: pointer;
  text-transform: none;
  font-weight: 400;
  letter-spacing: normal;
}

.step-info__checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

</style>
